export const ProjectCodeSchema = {
  Header: {
    text: (el, s) => (s.key || s.type || '') + ' schema'
  },
  CodePreviewWidget: {
    Monaco: {
      fileTab: {
        code: (el, s) => {
          const { type, key } = s
          if (!type) return `// select category or file`
          const typeFactory = el.getSchema(type)
          const code = el.stringifyCode(key ? typeFactory[key] : typeFactory)
          return code
        },
        filename: 'schema.js',
        fileTabKey: 'schema'
      },
      onCodeEditCallback: async (editor, _, el, s) => {
        const code = editor.getValue()
        // USER-CODE-ORIGIN review N5: PARSE the buffer (shared methods/code.js
        // parseStringCode — an acorn AST walk, no eval). The buffer starts from code a
        // co-editor stored; evalStringCodeUnsafe ran it on this origin with the
        // editor's session. Function fields stay their source text, the stored form —
        // only the opaque user-code frame revives it.
        await el.call('parseStringCode', code, {
          onError: (err) => {
            s.update({
              err
            })
          }
        })
      }
    }
  },
  // Fill-contrast column separation from the sibling ProjectCodeData pane
  // (was a left-edge `line` divider — border-habit sweep, design-direction.md
  // §8).
  background: 'overlay'
}
